import {
  ADD_MESSAGE,
  type IAppReducerAction,
  REMOVE_MESSAGE,
} from "src/app/reducers/AppReducer";
import type { ThunkResult } from "src/app/reducers/IMainAppState";
import { sleep } from "src/shared/async/sleep";
import type { Message } from "src/shared/messages/components/Messages";

export function AddMessage(
  message: Message,
  timeout: number = 5000,
): ThunkResult<void> {
  return (dispatch) => {
    dispatch({
      type: ADD_MESSAGE,
      message,
    });

    sleep(timeout).then(() => {
      dispatch(RemoveMessage(message));
    });
  };
}

export function RemoveMessage(message: Message): IAppReducerAction {
  return {
    type: REMOVE_MESSAGE,
    message,
  };
}
